// DS: IL5.7
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
  size?: number;
}

const BoostIllustration: React.FC<Props> = ({ size = 96 }) => {
  const { t } = useTranslation();
  return (
    <img
      width={size}
      src="//st.deviantart.net/eclipse/illustrations/boost-deviation.png"
      alt={t('actionbar.boost.illustration.alt')}
    />
  );
};
BoostIllustration.displayName = 'BoostIllustration';

export default BoostIllustration;
